import { Typography } from './Typography';
import { Button } from './Button';
export function NotFound() {
  return (
    <section className="mx-auto flex min-h-[70vh] max-w-3xl flex-col items-center justify-center gap-7 px-5 text-center">
      <Typography variant="eyebrow" tone="muted">
        404
      </Typography>
      <Typography as="h1" variant="heading">
        Страница не найдена
      </Typography>
      <Typography tone="muted">Вернитесь на главную страницу Audit Vector.</Typography>
      <Button href="/">На главную</Button>
    </section>
  );
}
